// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__3J_tJ","svg":"style_svg__cRmRz"};